import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'

const DataDetailLoading = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding center-cont">
				<i className="icon icon_certificate_intro" />
				<h3 className="intro-tit mt_30">마이데이터 상세 정보를 불러오고 있어요!</h3>
				<p className="intro-sub-tit mt_10">현재 화면에서 나가도 마이데이터 연결하기는<br />
					계속 진행됩니다.<br />
					연결이 완료되면 알림을 통해 알려드려요.
				</p>
			</div>
		</div>
	)
}

export default DataDetailLoading
